import React, { Component } from 'react';
import {Button} from 'react-bootstrap';
import { handleFieldChange } from "../../../../Utils";
import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import Icon from '../../../../components/Icon';
import SelectWrap from "../../../../components/SelectWrap";

class Form extends Component {
    constructor(props) {
        super(props);

        if(this.props.link) {
            const { link } = this.props;

            this.state = {
                type: link.type,
                link: link.link,
                platform: link.platform,
                update: true
            };
        }
        else this.state = { type: '',  link: '' };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.onSubmit(Object.assign({}, this.state));
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit} style={{ height: "auto", maxWidth: "600px" }}>
                    <FieldGroup
                        name="type"
                        label="Type:"
                        onChange={this.handleFieldChange}
                        value={this.state.type}
                        disabled={this.state.update}
                        required
                    />
                    <FieldGroup
                        name="link"
                        label="Link:"
                        onChange={this.handleFieldChange}
                        value={this.state.link}
                        required
                    />

                    <SelectWrap
                        values={[ 'legacy', 'desktop' ]}
                        label="Plaftorm:"
                        name="platform"
                        onChange={this.handleFieldChange}
                        value={this.state.platform}
                    />

                    <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/>Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/AdkLinks/components/Form/index.js